import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const UserActions = createActionGroup({
  source: 'User API',
  events: {
    'Plan Permissions Loaded': emptyProps(),
    'Load Person Id': emptyProps(),
    'Load Person Id Success': props<{ personId: string }>(),
    'Load Person Id Failure': props<{ error: Error }>(),
  },
});

export const TopBarActions = createActionGroup({
  source: 'More Menu',
  events: {
    'Feedback Clicked': emptyProps(),
  },
});

export const MoreMenuActions = createActionGroup({
  source: 'More Menu',
  events: {
    'Feedback Clicked': emptyProps(),
  },
});
